import React from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
  message?: string;
};

export default function AccessDenied({ message }: Props) {
  const { t } = useTranslation();
  return (
    <div className="w-full flex items-center justify-center py-16" data-testid="access-denied">
      <div className="max-w-xl text-center">
        <h1 className="text-2xl font-semibold">{t('auth.accessDenied', 'Access Denied')}</h1>
        <p className="mt-3 text-sm text-gray-600">{message || t('auth.noPermission', 'You do not have the necessary permissions to access this page.')}</p>
      </div>
    </div>
  );
}
